export default __webpack_public_path__ + "static/media/addRed.d83e0394.svg";